import { getApiData, getApiTable } from "./qmsApiUtils";

export const PUBLISH_READY_STAGE = "Approval Completed";

export const PUBLISH_FIELD_OPTIONS = [
  { key: "DocumentId", label: "ID" },
  { key: "DocumentTitle", label: "Document" },
  { key: "DocumentStage", label: "Stage" },
  { key: "VersionNumber", label: "Version" },
  { key: "SystemDateTime", label: "Modified" },
  { key: "DocumentType", label: "Type" },
  { key: "DocumentCategoryAbberiviation", label: "Category" },
  { key: "CreatedBy", label: "Owner" },
];

export const DEFAULT_PUBLISH_COLUMNS = [
  "DocumentId",
  "DocumentTitle",
  "DocumentStage",
  "VersionNumber",
  "SystemDateTime",
  "CreatedBy",
];

export function getPublishDocumentsList(response) {
  const named = getApiTable(response, "DMS_MyVault_Documents");
  if (named.length) return named;

  const data = getApiData(response);
  if (!data || typeof data !== "object") return [];

  for (const key of Object.keys(data)) {
    const rows = data[key];
    if (!Array.isArray(rows) || !rows.length) continue;
    if (rows[0]?.DocumentId != null || rows[0]?.documentId != null) {
      return rows;
    }
  }

  return [];
}

export function isPublishReadyDocument(row) {
  return String(row?.DocumentStage || "").trim() === PUBLISH_READY_STAGE;
}

export function filterPublishReadyDocuments(documents) {
  return (documents || []).filter(isPublishReadyDocument);
}

export function canOpenPublishWorkspace(row) {
  if (!row?.DocumentId) return false;
  if (!isPublishReadyDocument(row)) return false;
  return Number(row?.IsCheckOut) !== 1;
}

export function getPublishFieldLabel(field) {
  return PUBLISH_FIELD_OPTIONS.find((option) => option.key === field)?.label || field;
}
